import { Message } from "./Message";
import { HUD } from "./HUD";

export class MessageManager {

    public static currentInstance: MessageManager;

    private message: Message;
    private lastMessageType: string;
    private nextMessageType: string;
    private messageBeingDisplayed: boolean;

    private game: Phaser.Game;

    constructor(game: Phaser.Game) {

        this.game = game;

        MessageManager.currentInstance = this;
        this.messageBeingDisplayed = false;

        this.lastMessageType = null;

        this.message = new Message(this.game);
        HUD.currentInstance.add(this.message);
    }

    public showMessage(type: string): void {

        if (!this.messageBeingDisplayed) {

            this.messageBeingDisplayed = true;
            this.lastMessageType = type;
            this.message.show(type);

        } else if (this.lastMessageType !== type) {

            this.nextMessageType = type;
        }
    }

    public onMessageRemoved(): void {

        if (this.nextMessageType != null) {
            this.message.show(this.nextMessageType);
            this.nextMessageType = null;
        } else {
            this.messageBeingDisplayed = false;
        }
    }
}
